var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveCashFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.75C1.5 3.33579 1.83579 3 2.25 3H13.5H13.75C14.1642 3 14.5 3.33579 14.5 3.75V10.25C14.5 10.6642 14.1642 11 13.75 11H13.5H2.5H2.25C1.83579 11 1.5 10.6642 1.5 10.25V10V4V3.75Z",
    fill: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7C10 8.10457 9.10457 9 8 9C6.89543 9 6 8.10457 6 7C6 5.89543 6.89543 5 8 5C9.10457 5 10 5.89543 10 7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7H12.005V7.005H12V7Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7H4.005V7.005H4V7Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.5C5.1448 12.5 8.67573 12.9875 12.0312 13.9008C12.5158 14.0327 13 13.6724 13 13.1701V12.5M2.5 3V3.5C2.5 3.77614 2.27614 4 2 4H1.5M1.5 4V3.75C1.5 3.33579 1.83579 3 2.25 3H13.5M1.5 4V10M13.5 3V3.5C13.5 3.77614 13.7239 4 14 4H14.5M13.5 3H13.75C14.1642 3 14.5 3.33579 14.5 3.75V10.25C14.5 10.6642 14.1642 11 13.75 11H13.5M14.5 10H14C13.7239 10 13.5 10.2239 13.5 10.5V11M13.5 11H2.5M2.5 11H2.25C1.83579 11 1.5 10.6642 1.5 10.25V10M2.5 11V10.5C2.5 10.2239 2.27614 10 2 10H1.5M10 7C10 8.10457 9.10457 9 8 9C6.89543 9 6 8.10457 6 7C6 5.89543 6.89543 5 8 5C9.10457 5 10 5.89543 10 7ZM12 7H12.005V7.005H12V7ZM4 7H4.005V7.005H4V7Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCashFilter);
export default __webpack_public_path__ + "static/media/active-cash-filter.9c27d8c3419938102a62849a60764c7a.svg";
export { ForwardRef as ReactComponent };